
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class LocationTransferGrid extends Serenity.EntityGrid<LocationTransferRow, any> {
        protected getColumnsKey() { return 'Inventory.LocationTransfer'; }
        protected getDialogType() { return LocationTransferDialog; }
        protected getIdProperty() { return LocationTransferRow.idProperty; }
        protected getInsertPermission() { return LocationTransferRow.insertPermission; }
        protected getLocalTextPrefix() { return LocationTransferRow.localTextPrefix; }
        protected getService() { return LocationTransferService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
        }

        protected addButtonClick() {
            
            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(37);

            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[37].AutoPosting;

            let exchangerate = 1;
            if (userDefinition.CurrencyId != null && userDefinition.CurrencyId > 0)
                exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId == userDefinition.CurrencyId)[0].ExchRate; 
            this.editItem(<LocationTransferRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                EmployeeId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                ExchRate: exchangerate,
                VoucherTypeId: 37,
                TransDate: now.toDateString(),
                AutoPosting: autoposting,
                UserId: userDefinition.UserId
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}